import { z } from "zod/v4";

export const leagueIdSchema = z.union([
  z.literal("NBA"),
  z.literal("NFL"),
  z.literal("WNBA"),
  z.literal("SOCCER"),
]);

export type LeagueId = z.infer<typeof leagueIdSchema>;